import {
  View,
  Text,
  Button,
  Flex,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import * as React from "react";

export function FooterWithForgotPassword() {
  const { toResetPassword } = useAuthenticator();

  return (
    <View textAlign="center" padding="1rem">
      <Button
        fontWeight="normal"
        onClick={toResetPassword}
        size="small"
        variation="link"
        placeholder={undefined}
      >
        Forgot your password?
      </Button>

      <Footer />
    </View>
  );
}

export function Footer() {
  return (
    <View textAlign="center">
      {/* Extra spacing */}
      <Flex
        marginTop="1.5rem"
        alignItems="flex-start"
        justifyContent="center"
        gap="0.5rem"
        placeholder={undefined}
      >
        {/* Notice Sign */}
        <Text
          fontWeight="bold"
          color="orange"
          fontSize="0.85rem"
          placeholder={undefined}
        >
          ⚠ NOTICE
        </Text>

        {/* Notice Text */}
        <Text
          fontSize="0.8rem"
          color="var(--amplify-colors-brand-primary-80)"
          textAlign="left"
          maxWidth="320px"
          lineHeight="1.2rem"
          placeholder={undefined}
        >
          For non-U.S. users: provide only non-personal information and ensure
          all use complies with applicable laws and your organization's internal
          policies.
        </Text>
      </Flex>
    </View>
  );
}
